//BootstrapStarterCard.jsx
import { useCardMenuEffectPerRow } from './BootstrapStarterCardUtilities';
import FunctionsManagerRows from './FunctionsManagerRows';
import FunctionsTagApplier from './FunctionsTagApplier';
import BootstrapStarterCardCardOptions from './BootstrapStarterCardCardOptions';
import BootstrapStarterCardFavoriteStylesContainer from './BootstrapStarterCardFavoriteStylesContainer';

import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'react-bootstrap';
import './WriterCard.css';
import 'react-quill/dist/quill.snow.css';

import TextBox from './TextBox'
import ToolSavedStylesContainer from './ToolSavedStylesContainer';
import FunctionsShowOnlyActiveCardOrAnnotationStylebar from './FunctionsShowOnlyActiveCardOrAnnotationStylebar';
import './CSSToolStylesManagerToolForCard.css';
import './CSSToolStylesManagerToolForFavs.css';

import './WriterMode.css';
import './CSSColumnThree.css';


const BootstrapStarterCard = ({
    hideAllTools,
    hideMainMenu,
    writerMode,
    colorMode,
    rows,
    setRows,
    columns,
    setColumns,
    listItems,
    setListItems,
    onReceiveSavedStyles,
    savedStylesForLoading,
    cardInstanceId = 'default'
}) => {
    const [isViewDoc, setIsViewDoc] = useState(() => document.querySelector('.view-doc') !== null);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const found = document.querySelector('.view-doc') !== null;
            setIsViewDoc(found);
        });

        observer.observe(document.body, { attributes: true, childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);
    const [columnSizesByRow, setColumnSizesByRow] = useState({});
    const [annotationExpandedByRow, setAnnotationExpandedByRow] = useState({});

    const toggleCol2AndCol5Sizes = (rowId) => {
        setColumnSizesByRow(prev => ({
            ...prev,
            [rowId]: prev[rowId]
                ? null // collapsed state
                : { col2: '5/12', col5: '3/12' } // expanded state
        }));

        setAnnotationExpandedByRow(prev => ({
            ...prev,
            [rowId]: !prev[rowId] // toggle current state
        }));
    };

    const [optionsBoxPositions, setOptionsBoxPositions] = useState({});

    const deleteFavoriteStyleFromFixedPositionFavoriteStylesContainer = (styleName, visible, index, options) => {
        console.log("ABC Parent received delete request:", { styleName, visible, index, ...options });

        setSavedStyles(prevStyles => {
            const updatedStyles = [...prevStyles];
            updatedStyles.splice(index, 1);
            return updatedStyles;
        });

        setFavoriteStyleVisibilityMap(prev => ({
            ...prev,
            [index]: false,
        }));
    };



    const [favoriteStyleVisibilityMap, setFavoriteStyleVisibilityMap] = useState({});
    const sendFavoriteVisibilityToParentUpdate = (index, isVisible) => {
        setFavoriteStyleVisibilityMap(prev => ({
            ...prev,
            [index]: isVisible
        }));
    };


    useEffect(() => {
        console.log("Received savedStylesForLoading from BootstrapStarterBody:", savedStylesForLoading);
    }, [savedStylesForLoading]);

    const textBoxRefs = useRef({});
    const [lastFocusedEditorKey, setLastFocusedEditorKey] = useState(null);

    const {
        createNewRowAbove,
        createNewRowBelow,
        moveRowUp,
        moveRowDown,
        deleteRow
    } = FunctionsManagerRows({ rows, setRows });

    const [openMenus, setOpenMenus] = useState({});
    const [savedStyles, setSavedStyles] = useState([]);
    React.useEffect(() => {
        console.log("Updated savedStyles in BootstrapStarterCard:", savedStyles);
    }, [savedStyles]);

    const toggleMenuForRow = (rowId, menuType) => {
        setOpenMenus(prev => ({
            ...prev,
            [rowId]: prev[rowId] === menuType ? null : menuType
        }));
    };

    const isMenuOpenForRow = (rowId, menuType) => openMenus[rowId] === menuType;

    useCardMenuEffectPerRow(openMenus, setOpenMenus);

    const handleSaveTextStyle = (style) => {
        console.log("Saved style:", style);
        setSavedStyles(prevStyles => [...prevStyles, style]);
    };
    let hasRenderedToolSavedStylesContainer = false;
    useEffect(() => {
        console.log("All savedStyles in state:", savedStyles);
    }, [savedStyles]);

    const handleDeleteSavedStyle = (index) => {
        console.log(`BootstrapStarterCard.jsx received onDeleteSavedStyle from ToolSavedStylesContainer.jsx: ${index}`);

        setSavedStyles(prevStyles => {
            const updatedStyles = [...prevStyles];
            updatedStyles.splice(index, 1);
            return updatedStyles;
        });

        setFavoriteStyleVisibilityMap(prev => {
            const newMap = {};

            Object.entries(prev).forEach(([key, value]) => {
                const keyNum = parseInt(key, 10);
                if (keyNum < index) {
                    newMap[keyNum] = value;
                } else if (keyNum > index) {
                    newMap[keyNum - 1] = value;
                }
            });

            return newMap;
        });
    };

    const [showOptionsBox, setShowOptionsBox] = useState({});
    const optionsBoxRefs = useRef({});

    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if any options box should be closed
            let shouldUpdate = false;
            const newShowOptionsBox = { ...showOptionsBox };

            Object.entries(optionsBoxRefs.current).forEach(([key, ref]) => {
                if (ref && !ref.contains(event.target) && showOptionsBox[key]) {
                    newShowOptionsBox[key] = false;
                    shouldUpdate = true;
                }
            });

            if (shouldUpdate) {
                setShowOptionsBox(newShowOptionsBox);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showOptionsBox]); // Add showOptionsBox as dependency

    // Generate unique keys that include the card instance ID
    const generateUniqueKey = (type, rowId, colId) => {
        return `${cardInstanceId}-${type}-${rowId}-${colId}`;
    };

    const checkCol2FullHeightOnExpandingCol5 = (rowId) => {
        console.log(`Checking for full height textboxes in row ${rowId} for card instance ${cardInstanceId}`);

        // Use setTimeout to ensure DOM is fully updated after the column size change
        setTimeout(() => {
            // Method 1: Search for the specific card container first, then find its column 2
            const cardContainer = document.querySelector(`#cardContainer-${rowId}-1`); // Assuming column 1 exists
            if (!cardContainer) {
                console.log(`Card container for row ${rowId} not found`);
                return;
            }

            // Find the column 2 container that's a sibling or ancestor of this card container
            const col2Container = cardContainer.closest(`#appBodyCol2-${cardInstanceId}`) ||
                cardContainer.closest('[id^="appBodyCol2-"]');

            if (!col2Container) {
                console.log('Column 2 container not found');
                return;
            }

            // Find all textbox containers within this column 2 that belong to the specific row
            const textBoxContainers = col2Container.querySelectorAll('.textBoxPlacement');

            textBoxContainers.forEach((textBoxContainer, index) => {
                // Check if this textbox belongs to our target row by looking for the row ID in nearby elements
                const relatedCardContainer = textBoxContainer.closest(`[id*="cardContainer-${rowId}-"]`);
                if (relatedCardContainer) {
                    const toggleButton = textBoxContainer.querySelector('#buttonToggleFixedHeightAutoHieght');
                    const buttonText = textBoxContainer.querySelector('#buttonToggleFixedHeightAutoHieght .button-text');

                    console.log(`Found textbox for row ${rowId}, button text:`, buttonText?.textContent);

                    // If button text reads "Set View to Fixed Height", it means it's currently at full height
                    if (buttonText && buttonText.textContent.includes('Set View to Fixed Height')) {
                        console.log(`Clicking button to switch to fixed height for row ${rowId}`);
                        if (toggleButton) {
                            toggleButton.click();
                        }
                    }
                }
            });
        }, 100); // Give DOM time to update
    };

    const getAnnotationIcon = ({ expanded, hovered, isViewDoc, isViewDark }) => {
        let base = expanded ? 'annotation-collapse' : 'annotation-expand';
        if (hovered) base += '-hover';
        if (isViewDoc) base += '-doc';
        if (isViewDark) base += '-dark';
        return `/SVGicons/${base}.svg`;
    };

    return (
        <div className={
            (writerMode === 'Doc' ? 'view-doc' :
                writerMode === 'Note Pad' ? 'view-notepad' :
                    writerMode === 'Sticky Note' ? 'view-stickynote' : '') +
            (colorMode === 'Neutral' ? ' view-neutral' :
                colorMode === 'Dark' ? ' view-dark' : '')
        }>
            <FunctionsShowOnlyActiveCardOrAnnotationStylebar />
            <div id="cardTextBox" className="colorTest">
                {/* Card Test Box */}
            </div>

            {/* Parent Container*/}
            <div
                id={`appBodyColumnWriterRow-${cardInstanceId}`} // Make container ID unique
                className="row salmon"
            >

                {rows.map(row => (

                    <div key={row.id} className="cardSpacer"
                        style={{ display: 'flex' }}
                    >

                        {/* column 1of5 card options */}
                        <div id="appBodyCol1" className="col-1 gray column1of5 cardOptionsTextContainerOuter">
                            {/* ONE */}
                            <div id="cardOptionsTextContainer" className="cardOptionsTextContainer">

                                <div id="cardNameContainerForColumnOne" className="cardNameContainerForColumnOne">

                                    <div
                                        id="cardNameContainerForColumnOnePartOne"
                                        className="cardNameContainerForColumnOnePartOne"
                                    >
                                        {columns.map(col => (
                                            <div key={`text-${col.id}-row-${row.id}`}>
                                                <div
                                                    id="cardNameContainerForColumnOneInputBox"
                                                    className="cardNameContainerForColumnOneInputBox"
                                                >
                                                    <textarea
                                                        className="cardNameContainerForColumnOneInputBoxField"
                                                        rows={1}
                                                        value={row[`cardName_${col.id}`] ?? ''}
                                                        placeholder={`Card ${row.id}`}
                                                        onChange={e => {
                                                            const textarea = e.target;

                                                            // Wait until after DOM updates before adjusting height
                                                            requestAnimationFrame(() => {
                                                                textarea.style.height = 'auto';

                                                                // Optional: prevent unnecessary resizing
                                                                const newHeight = `${textarea.scrollHeight}px`;
                                                                if (textarea.style.height !== newHeight) {
                                                                    textarea.style.height = newHeight;
                                                                }
                                                            });

                                                            const updatedRows = rows.map(r =>
                                                                r.id === row.id
                                                                    ? { ...r, [`cardName_${col.id}`]: e.target.value }
                                                                    : r
                                                            );
                                                            setRows(updatedRows);
                                                        }}
                                                        ref={el => {
                                                            if (el) {
                                                                // Allow initial fit-to-content height
                                                                requestAnimationFrame(() => {
                                                                    el.style.height = 'auto';
                                                                    el.style.height = `${el.scrollHeight}px`;
                                                                });
                                                            }
                                                        }}
                                                        maxLength={220}
                                                        style={{
                                                            // position: 'relative',
                                                            // zIndex: 2,
                                                            overflowY: 'hidden',
                                                            resize: 'none',
                                                        }}
                                                    />

                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <div
                                        id="cardNameContainerForColumnOnePartTwo"
                                        className="cardNameContainerForColumnOnePartTwo"
                                    >

                                        <div id="cardOptionsTextContainerCardID" className="cardOptionsTextContainerCardID">
                                            (Card ID: {row.id})
                                        </div>
                                        <div id="cardOptionsTextContainerMiddleText" className="cardOptionsTextContainerMiddleText">
                                            is in
                                        </div>
                                        <div id="cardOptionsTextContainerRowLocation" className="cardOptionsTextContainerRowLocation">
                                            Row: {row.position}
                                        </div>

                                        {/* Card Options Button */}
                                        <BootstrapStarterCardCardOptions
                                            row={row}
                                            toggleMenuForRow={toggleMenuForRow}
                                            hideMainMenu={hideMainMenu}
                                            isMenuOpenForRow={isMenuOpenForRow}
                                            createNewRowAbove={createNewRowAbove}
                                            createNewRowBelow={createNewRowBelow}
                                            moveRowUp={moveRowUp}
                                            moveRowDown={moveRowDown}
                                            deleteRow={deleteRow}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* column 2 of 5 card content*/}
                        <div
                            id={`appBodyCol2-${cardInstanceId}`}
                            className="gray column2of5 animated-column-transition"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: writerMode === 'Doc' ? 'none' : '1',
                                width: '100%',
                                minWidth: 0,
                                flexShrink: writerMode === 'Doc' ? 0 : 1
                            }}
                        >
                            {/* TWO */}
                            {columns.map(col => (
                                <div key={`text-${col.id}-row-${row.id}`}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flex: '1'
                                    }}
                                >

                                    <div className="cardNameContainerForColumnTwoButtonBoxParentForPosition" >
                                        <div id="cardNameContainer" className="cardNameContainerForColumnTwo">
                                            <div id="cardNameContainerForColumnTwoButtonBox" className="cardNameContainerForColumnTwoButtonBox">
                                                <Button
                                                    onClick={() => {
                                                        toggleMenuForRow(row.id, 'cardOptions');
                                                        hideMainMenu();
                                                    }}
                                                    id="buttonCardManager"
                                                    className="responsive-icon-button btn-sm buttonCardManagerhover"
                                                    style={{
                                                        position: 'relative',
                                                        zIndex: 2,
                                                    }}
                                                >
                                                    <div id="iconCardManagerImageBox" className="iconCardManagerImageBox">
                                                        <img className="buttonCardManagerImg" alt="Card Options" />
                                                    </div>
                                                </Button>
                                            </div>
                                            <div id="cardNameContainerForColumnTwoInputBox" className="cardNameContainerForColumnTwoInputBox">
                                                <textarea
                                                    className="cardNameContainerForColumnTwoInputBoxField"
                                                    rows={1}
                                                    value={row[`cardName_${col.id}`] ?? ''}
                                                    placeholder={`Card ${row.id}`}
                                                    onChange={e => {
                                                        const textarea = e.target;

                                                        requestAnimationFrame(() => {
                                                            textarea.style.height = 'auto';
                                                            const newHeight = `${textarea.scrollHeight}px`;
                                                            if (textarea.style.height !== newHeight) {
                                                                textarea.style.height = newHeight;
                                                            }
                                                        });

                                                        const updatedRows = rows.map(r =>
                                                            r.id === row.id
                                                                ? { ...r, [`cardName_${col.id}`]: e.target.value }
                                                                : r
                                                        );
                                                        setRows(updatedRows);
                                                    }}
                                                    ref={el => {
                                                        if (el) {
                                                            requestAnimationFrame(() => {
                                                                el.style.height = 'auto';
                                                                el.style.height = `${el.scrollHeight}px`;
                                                            });
                                                        }
                                                    }}
                                                    maxLength={220}
                                                    style={{
                                                        position: 'relative',
                                                        overflowY: 'hidden',
                                                        resize: 'none',
                                                    }}
                                                />

                                            </div>
                                            <div id="cardNameContainerForColumnTwoIDAndPositionBox" className="cardNameContainerForColumnTwoIDAndPositionBox">

                                                <div id="cardOptionsTextContainerCardID" className="cardOptionsTextContainerCardID">
                                                    <span className="cardOptionsTextContainerCardIDViewRulesID">(Card ID: {row.id}) is in </span>
                                                    <span className="cardOptionsTextContainerCardIDViewRulesRow">Row: {row.position}</span>
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                    <div className="cardContainerParentForPositionOuter"
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            flex: '1'
                                        }}
                                    >

                                        <div className="cardContainerParentForPosition"
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                flex: '1'
                                            }}
                                        >
                                            <div
                                                id={`cardContainer-${row.id}-${col.id}`}
                                                className="cardAndAnnotationContainerBorderOnHover cardMarginTopAdjust"
                                                tabIndex="0"
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    flex: writerMode === 'Doc' ? 'none' : '1',
                                                    minWidth: writerMode === 'Doc' ? '100%' : '0',
                                                    width: writerMode === 'Doc' ? '100%' : '100%',
                                                    flexShrink: writerMode === 'Doc' ? 0 : 1
                                                }}
                                            >
                                                {/* Card Text Box */}
                                                <div
                                                >
                                                    <TextBox
                                                        ref={el => textBoxRefs.current[generateUniqueKey('card', row.id, col.id)] = el}
                                                        id={`textBoxForCard-${cardInstanceId}-${row.id}-${col.id}`}
                                                        content={row[`column${col.id}`] || ''}
                                                        onContentChange={(value) => {
                                                            const currentContent = row[`column${col.id}`] || '';
                                                            if (currentContent !== value) {
                                                                const updatedRows = rows.map(r =>
                                                                    r.id === row.id ? { ...r, [`column${col.id}`]: value } : r
                                                                );
                                                                setRows(updatedRows);
                                                            }
                                                        }}
                                                        onSaveStyle={handleSaveTextStyle}
                                                        onFocus={() => setLastFocusedEditorKey(generateUniqueKey('card', row.id, col.id))}
                                                    />
                                                </div>


                                            </div>
                                            {/* Syncronized Annotation Box for Writer Mode */}
                                        </div>
                                    </div>

                                </div>
                            ))}
                        </div>

                        <div id="appBodyCol3" className="col-1 col-md-3 gray column3of5"
                        >
                            <div
                                id="annotationRevealerContainer"
                                className="annotationRevealerContainer"
                            >
                                <button
                                    id="buttonAnnotationRevealerContainer"
                                    className="buttonAnnotationRevealerContainer"
                                    onClick={() => {
                                        toggleCol2AndCol5Sizes(row.id);
                                        checkCol2FullHeightOnExpandingCol5(row.id);
                                    }}
                                    onMouseEnter={(e) => {
                                        const img = e.currentTarget.querySelector('img');
                                        const isExpanded = annotationExpandedByRow[row.id];
                                        const isViewDark = !!e.currentTarget.closest('.view-dark');
                                        img.src = getAnnotationIcon({
                                            expanded: isExpanded,
                                            hovered: true,
                                            isViewDoc,
                                            isViewDark
                                        });
                                    }}
                                    onMouseLeave={(e) => {
                                        const img = e.currentTarget.querySelector('img');
                                        const isExpanded = annotationExpandedByRow[row.id];
                                        const isViewDark = !!e.currentTarget.closest('.view-dark');
                                        img.src = getAnnotationIcon({
                                            expanded: isExpanded,
                                            hovered: false,
                                            isViewDoc,
                                            isViewDark
                                        });
                                    }}
                                >
                                    <img
                                        id={`buttonAnnotationRevealerContainerImg-${row.id}`}
                                        className="buttonAnnotationRevealerContainerImg"
                                        src={getAnnotationIcon({
                                            expanded: annotationExpandedByRow[row.id],
                                            hovered: false,
                                            isViewDoc,
                                            isViewDark: !!document.querySelector('.view-dark') // or pass a prop instead
                                        })}
                                        alt="Reveal or Hide This Card's Annotation"
                                    />
                                </button>



                            </div>
                            {/* column 3 of 5 tag applier*/}
                            {/* Buttons for saved text styles */}
                            {!hasRenderedToolSavedStylesContainer && (
                                <div className="row appBodyCol2TagContainerParent">
                                    <div
                                        className="appBodyCol2TagContainerOuter"
                                    >
                                        <div
                                            className="appBodyCol2TagContainerInner"
                                        >
                                            <div
                                                id="toolSavedStylesContainerPosition"
                                                className="toolSavedStylesContainerPosition"
                                                style={{
                                                    visibility: 'hidden'
                                                }}
                                            >
                                                <div className="toolSavedStylesContainerPositionScollableContainer">

                                                    {/* Render header and button groups */}
                                                    <BootstrapStarterCardFavoriteStylesContainer
                                                        favoriteStyleVisibilityMap={favoriteStyleVisibilityMap}
                                                        savedStyles={savedStyles}
                                                        optionsBoxPositions={optionsBoxPositions}
                                                        setOptionsBoxPositions={setOptionsBoxPositions}
                                                        showOptionsBox={showOptionsBox}
                                                        setShowOptionsBox={setShowOptionsBox}
                                                        optionsBoxRefs={optionsBoxRefs}
                                                    />

                                                    <ToolSavedStylesContainer
                                                        savedStyles={savedStyles}
                                                        setSavedStyles={setSavedStyles}
                                                        textBoxRefs={textBoxRefs}
                                                        lastFocusedEditorKey={lastFocusedEditorKey}
                                                        sendSavedStyles={onReceiveSavedStyles}
                                                        savedStylesForLoading={savedStylesForLoading}
                                                        sendFavoriteVisibilityToParent={(styleName, visible, index) => {
                                                            sendFavoriteVisibilityToParentUpdate(index, visible);
                                                            console.log(`sendFavoriteVisibilityToParent called with styleName: ${styleName}, visible: ${visible}, index: ${index}`);
                                                        }}
                                                        deleteFavoriteStyleFromFixedPositionFavoriteStylesContainer={deleteFavoriteStyleFromFixedPositionFavoriteStylesContainer} // ✅ make sure this is defined!
                                                        onDeleteSavedStyle={handleDeleteSavedStyle}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {hasRenderedToolSavedStylesContainer = true}


                            <FunctionsTagApplier
                                row={row}
                                toggleMenuForRow={toggleMenuForRow}
                                hideMainMenu={hideMainMenu}
                                isMenuOpenForRow={isMenuOpenForRow}
                                columns={columns}
                                rows={rows}
                                setRows={setRows}
                                listItems={listItems}
                            />

                            {/* Mobile Tool Accessor */}

                        </div>

                        {/* column 5 of 5 card content*/}
                        <div
                            id={`appBodyCol5-${cardInstanceId}`}
                            className={`gray animated-column-transition ${writerMode === 'Doc' && columnSizesByRow[row.id]?.col5 === '3/12' ? 'annotation-grow' : ''
                                }`}
                            style={{
                                flexBasis: columnSizesByRow[row.id]?.col5 === '3/12' ? '65%' : '8.3333%',
                                height: columnSizesByRow[row.id]?.col5 === '3/12' ? 'auto' : '25px',
                                overflow: columnSizesByRow[row.id]?.col5 === '3/12' ? 'visible' : 'hidden',
                                borderBottom: columnSizesByRow[row.id]?.col5 === '3/12' ? 'none' : '1px solid black',
                                transition: 'flex-basis 0.4s ease-in-out, height 0.3s ease, border-bottom 0.3s ease',
                                cursor: columnSizesByRow[row.id]?.col5 === '3/12' ? 'default' : 'pointer',
                                zIndex: writerMode === 'Doc' && columnSizesByRow[row.id]?.col5 === '3/12' ? 9999 : 'auto'
                            }}
                            onClick={() => {
                                if (columnSizesByRow[row.id]?.col5 !== '3/12') {
                                    toggleCol2AndCol5Sizes(row.id);
                                }
                            }}
                        >
                            {/* FIVE */}
                            {columns.map(col => (
                                <div key={`annotation-${row.id}-${col.id}`} className="cardContainerParentForPositionOuterCol5">
                                    <div className="cardContainerParentForPosition">
                                        <div
                                            id={`annotationContainer-${row.id}-${col.id}`}
                                            className="cardAndAnnotationContainerBorderOnHover annotationViewDocViewDarkHidden"
                                        >
                                            <TextBox
                                                ref={el => textBoxRefs.current[generateUniqueKey('annotation', row.id, col.id)] = el}
                                                id={`textBoxForAnnotation-${cardInstanceId}-${row.id}-${col.id}`}
                                                content={row[`column${col.id}_annotation`] || ''}
                                                onContentChange={(value) => {
                                                    const updatedRows = rows.map(r =>
                                                        r.id === row.id ? { ...r, [`column${col.id}_annotation`]: value } : r
                                                    );
                                                    setRows(updatedRows);
                                                }}
                                                onSaveStyle={handleSaveTextStyle}
                                                onFocus={() => setLastFocusedEditorKey(generateUniqueKey('annotation', row.id, col.id))}
                                            />

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <br />
        </div>
    );
};
export default BootstrapStarterCard;